import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import CreateContent from './CreateContent';
import EditContent from './EditContent';
import {
  SLEditModal,
  SLCreateModal,
} from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from "react-redux";

export default function FechamentoOS() {
  const [data, setData] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [anos, setAnos] = useState([]);
  const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());
  const [analistas, setAnalistas] = useState([]);
  const [analistaFiltro, setAnalistaFiltro] = useState([]);

  useEffect(() => {
    setLoadedData(false);
  }, [analistaFiltro]);

  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));

      api.get("/signed/empresa/gestorprojeto/gerencia/analistas", { params: { ativo: 1 } })
        .then(response => setAnalistas(response.data));

      setAnos([
        { id: new Date().getFullYear() - 2 },
        { id: new Date().getFullYear() - 1 },
        { id: new Date().getFullYear() },
      ])
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-pj"
            requests={{
              findAll: () =>
                api.get(
                  '/signed/empresa/gestorprojeto/fechamentosos',
                  { params: { idAnalista: analistaFiltro, ano: anoAtivo } },
                ),
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/fechamentoos', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/gestorprojeto/fechamentoos', {
                  data: { id: thisData.id },
                }),
            }}
            selects={[
              {
                list: analistas,
                value: "id",
                label: "nome",
                outLabel: "Todos os Analistas",
                filter: "analistas.idAnalista",
                onChange: (idAnalista) => {
                  setAnalistaFiltro(idAnalista);
                }
              },
              {
                list: anos,
                value: "id",
                label: "id",
                outLabel: "Todos os Anos",
                filter: "anoFechamento",
                onChange: (ano) => {
                  setAnoAtivo(ano);
                }
              },
            ]}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: "Fechamento de Ordem de Serviço",
              subTitle: "Realize o fechamento das OS para realizar o pagamento das OS's",
              icone: "submenu-relatorio-projeto",
            }}
            inputs={[
              { filter: "titulo", label: "Titulo" },
              { filter: "id", label: "Id" },
            ]}
          >
            <SLCreateModal menu={true} title="Adicionar Fechamento da Ordem de Serviço">
              {analistas && <CreateContent {...{ analistas }} />}
            </SLCreateModal>

            <SLEditModal
              menu={true}
              title="Atualizar Fechamento da Ordem de Serviço"
              setter={setMountedData}
            >
              {mountedData && (
                <EditContent {...{ mountedData, analistas }} />
              )}
            </SLEditModal>

            <CustomBodyContent {...{ data, setPageData }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
